import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Timeformat from "../../utils/Timeformat";

class LicenceContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

    }

    render() {

        const currentCompany = this.props.baseData.companies.currentCompany;
        if (!currentCompany) {
            return (
                <div className="formSettings">
                    <nav>
                        <h1>{this.translate('licence')}</h1>
                    </nav>
                    <div className="formRow">
                        <p>{this.translate('loading')}</p>
                    </div>
                </div>
            );
        }

        const timezone = currentCompany.timezone;
        const company = currentCompany;
        const dateLicencedTill = company.date_licenced;
        const licencedTill = (dateLicencedTill) ? Timeformat.fromUnix(dateLicencedTill).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
        const installKey = (company.install_key) ? company.install_key.substr(company.install_key.length - 5) : '';

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('licence')}</h1>
                </nav>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('licenceFor')}</td>

                                <td className="text-left">
                                    <input name="companyName"
                                           type="text"
                                           value={company.name}
                                           disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('myzskLoginId')}</td>

                                <td className="text-left">
                                    <input name="myzskLoginId"
                                           type="text"
                                           value={company.main_user_email}
                                           disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('dateLicencedTill')}</td>

                                <td className="text-left">
                                    <input name="validUntil"
                                           type="text"
                                           value={licencedTill}
                                           disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('installKey')}</td>

                                <td className="text-left">
                                    <input name="installKey"
                                           type="text"
                                           value={installKey}
                                           disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('extendLicense')}</td>

                                <td className="text-left">
                                    <a href="https://shop.zsk.de" target="_blank" style={{fontWeight: 600}}>{this.translate('linkToShop')}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default LicenceContainer;
